import { render, staticRenderFns } from "./OpenInZohoButton.vue?vue&type=template&id=7f149968"
import script from "./OpenInZohoButton.vue?vue&type=script&lang=js"
export * from "./OpenInZohoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports